import React, { useState, useEffect } from "react";
import { DropDown, Field, DatePickerField } from "./textField";
import { Autocomplete, TextField } from "@mui/material";
import LocationAutocomplete from "./locationDropdown";
import { fetchFoundationRoles } from "../api/serverApi";

export const CreationForm = ({
  responseData,
  responseDataLocation,
  responseSiteType,
  propertyTaxData,
  selectedPropertyTax,
  onChangePropertyTax,
  nameLocation,
  nameState,
  onChangeLocation,
  onChangeSite,
  onChangeState,
  onChangeSiteType,
  stateId,
  locationId,
  selectedLocationId,
  selectedLocationValue,
  selectedStateId,
  selectedSiteType,
  onChange,
  description,
  isEditing,
}) => {
  console.log("Site Type Data:", responseSiteType);
  return (
    <>
      <div className="py-2">
        <DropDown
          title="State*"
          placeholder="None"
          responseData={responseData}
          labelKey={nameState}
          valueKey={stateId}
          onChange={onChangeState}
          value={selectedStateId}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
          disabled={isEditing}
        />
      </div>

      <div className="py-2">
        <LocationAutocomplete
          title="Location*"
          placeholder="None"
          responseData={responseDataLocation}
          labelKey="name"
          onChange={onChangeLocation}
          value={selectedLocationValue}
          disabled={isEditing}
        />
      </div>

      <div className="py-2">
        <Field
          type="text"
          label="Site*"
          onChange={onChangeSite}
          disabled={isEditing}
        />
      </div>

      <div className="py-2">
        <DropDown
          title="Site Type*"
          placeholder="Select Site Type"
          responseData={responseSiteType} // 👈 API data
          labelKey="name" // ✅ correct
          valueKey="site_type_id" // ✅ correct
          onChange={onChangeSiteType}
          value={selectedSiteType}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
          // disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <DropDown
          title="Property Tax Applicability*"
          placeholder="Select Property Tax Applicability"
          responseData={propertyTaxData}
          labelKey="name"
          valueKey="property_tax_applicability_id"
          onChange={onChangePropertyTax}
          value={selectedPropertyTax}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Site Description"
          value={description}
          onChange={onChange}
        />
      </div>
    </>
  );
};

export const SurveyForm = ({
  siteName,
  responseData,
  selectedSiteID,
  siteId,
  onChangeSurveyNo,
  onChangeScheduleNo,
  onChangeAcres,
  onChangeGuntas,
  onChangeKarabAcres,
  onChangeKarabGuntas,
  responseDataState,
  stateName,
  selectedState,
  stateId,
  responseDataLocation,
  locationName,
  selectedLocation,
  locationId,
}) => {
  return (
    <>
      <div className="py-2">
        <DropDown
          title="State*"
          placeholder="None"
          responseData={responseDataState}
          labelKey={stateName}
          valueKey={selectedState}
          value={stateId} // ✅ PASS THE ID
          onChange={(e) => console.log(e.target.value)}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
      <div className="py-2">
        <DropDown
          title="Location*"
          placeholder="None"
          responseData={responseDataLocation}
          labelKey={locationName}
          valueKey={selectedLocation}
          value={locationId} // ✅ PASS THE ID
          onChange={(e) => console.log(e.target.value)}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
      <div className="py-2">
        <DropDown
          title="Site*"
          placeholder="None"
          responseData={responseData}
          labelKey={siteName}
          valueKey={selectedSiteID}
          value={siteId} // ✅ PASS THE ID
          onChange={(e) => console.log(e.target.value)}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>

      <div className="py-2">
        <Field label="Survey No*" onChange={onChangeSurveyNo} />
      </div>

      <div className="py-2">
        <Field type="text" label="Schedule No*" onChange={onChangeScheduleNo} />
      </div>
      <div className="py-2">
        <Field label="Area in Acres" onChange={onChangeAcres} />
      </div>
      <div className="py-2">
        <Field label="Area in Guntas" onChange={onChangeGuntas} />
      </div>
      <div className="py-2">
        <Field label="Karab in Acres" onChange={onChangeKarabAcres} />
      </div>
      <div className="py-2">
        <Field label="Karab in Guntas" onChange={onChangeKarabGuntas} />
      </div>
    </>
  );
};
export const CourtForm = ({
  siteName,
  responseData,
  selectedSiteID,
  siteId,
  onChangeSummary,
  onChangeOriginalSuite,
  OriginalSuiteDate,
  ClosureDate,
  NextHearingDate,

  onChangeCourtCaseDetails,
  onChangeLastDate,
  LastDate,
  onChangeAdvocateName,
  onChangeContactNumber,
  onChangeCaseRequirement,
  onChangeOriginalSuiteDate,
  onChangeNextHearingDate,
  onChangeClosureDate,
  onChangeUniqueNo,
  responseDataUniqueNo,
  uniqueNoName,
  selectedUniqueId,
  setSelectedUnique,
  uniqueNoId,
  responseDataState,
  stateName,
  selectedState,
  stateId,
  responseDataLocation,
  locationName,
  selectedLocation,
  locationId,
  onChangeLitigationAcre,
  onChangeLitigationGunta,
  onChangeFoundationRole,
  foundationRoleId,
  onChangePlaintiff,
  onChangeDefendant,

  onChangeImpleader,
  onChangeRespondent,
  onChangeIntervenor,
  onChangeAppellant,
  foundationRoleName,
  responseDataStatus,
  courtStatus,
  selectedCourtStatus,
  caseTypes,
  selectedCaseType,
  setSelectedCaseType,
  currentStatus,
  siteType,
  onChangeStatus,
  onChangeCnrNumber,
  courtStages,
  selectedCourtStage,
  setSelectedCourtStage,
}) => {
  const [foundationRoles, setFoundationRoles] = useState([]);

  // ✅ cleaner condition
  const isLand = siteType?.toLowerCase() !== "others";

  useEffect(() => {
    const loadRoles = async () => {
      try {
        const roles = await fetchFoundationRoles();
        setFoundationRoles(roles);
      } catch (error) {
        console.error("Error fetching foundation roles:", error);
      }
    };
    loadRoles();
  }, []);

  return (
    <>
      {/* State */}
      <div className="py-2">
        <DropDown
          title="State*"
          placeholder="None"
          responseData={responseDataState}
          labelKey={stateName}
          valueKey={selectedState}
          value={stateId}
          onChange={(e) => console.log(e.target.value)}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>

      {/* Location */}
      <div className="py-2">
        <DropDown
          title="Location*"
          placeholder="None"
          responseData={responseDataLocation}
          labelKey={locationName}
          valueKey={selectedLocation}
          value={locationId}
          onChange={(e) => console.log(e.target.value)}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>

      {/* Site */}
      <div className="py-2">
        <DropDown
          title="Site*"
          placeholder="None"
          responseData={responseData}
          labelKey={siteName}
          valueKey={selectedSiteID}
          value={siteId}
          onChange={(e) => console.log(e.target.value)}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>

      {/* Case Type */}
      <div className="py-2">
        <DropDown
          title="Court Case Type*"
          placeholder="Select"
          responseData={caseTypes || []}
          labelKey="name"
          valueKey="case_type_id"
          value={selectedCaseType}
          onChange={(e) => setSelectedCaseType(e.target.value)}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
      {isLand && (
        <div className="py-2">
          <Autocomplete
            multiple
            options={responseDataUniqueNo}
            getOptionLabel={(option) => option.unique_survey_no}
            value={uniqueNoId}
            onChange={(event, newValue) => {
              setSelectedUnique(newValue);
            }}
            renderInput={(params) => {
              // ✅ Get selected case object
              const selectedCaseObj = caseTypes?.find(
                (c) => c.case_type_id === selectedCaseType,
              );

              // ✅ Check if case type is Land
              const isLandCase =
                selectedCaseObj?.name === "Land" || selectedCaseType === "Land";

              return (
                <TextField
                  {...params}
                  label={
                    <>
                      Unique Survey No
                      {isLandCase && <span style={{ color: "blue" }}> *</span>}
                    </>
                  }
                  InputLabelProps={{ shrink: true }}
                />
              );
            }}
            sx={{ width: 550 }}
          />
        </div>
      )}
      {/* CNR Number */}
      <div className="py-2">
        <Field type="text" label="CNR Number*" onChange={onChangeCnrNumber} />
      </div>
      {/* Original Suite */}
      <div className="py-2">
        <Field
          type="text"
          label="Original Suite No*"
          onChange={onChangeOriginalSuite}
        />
      </div>
      {/* Court Case Details */}
      <div className="py-2">
        <Field
          type="text"
          label="Court Details*"
          onChange={onChangeCourtCaseDetails}
        />
      </div>
      {/* ✅ Acre & Gunta (only for land) */}
      {isLand && (
        <>
          <div className="py-2">
            <Field
              type="number"
              label="Area under Litigation in Acre"
              onChange={onChangeLitigationAcre}
            />
          </div>

          <div className="py-2">
            <Field
              type="number"
              label="Area under Litigation in Gunta"
              onChange={onChangeLitigationGunta}
            />
          </div>
        </>
      )}

      {/* Foundation Role */}
      <div className="py-2">
        <DropDown
          title="Foundation Role*"
          placeholder="Select"
          responseData={foundationRoles}
          labelKey="role_name"
          valueKey="foundation_role_id"
          value={foundationRoleId}
          onChange={(e) => {
            const selectedId = e.target.value;
            const selectedRole = foundationRoles.find(
              (r) => r.foundation_role_id === selectedId,
            );
            onChangeFoundationRole(selectedId, selectedRole?.role_name);
          }}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>

      {/* Plaintiff / Defendant */}
      {/* {foundationRoleName &&
        (foundationRoleName.toLowerCase() === "defendant" ? (
          <div className="py-2">
            <Field
              type="text"
              label="Plaintiff*"
              onChange={onChangePlaintiff}
            />
          </div>
        ) : foundationRoleName.toLowerCase() === "plaintiff" ? (
          <div className="py-2">
            <Field
              type="text"
              label="Defendant*"
              onChange={onChangeDefendant}
            />
          </div>
        ) : (
          <>
            <div className="py-2">
              <Field
                type="text"
                label="Plaintiff*"
                onChange={onChangePlaintiff}
              />
            </div>
            <div className="py-2">
              <Field
                type="text"
                label="Defendant*"
                onChange={onChangeDefendant}
              />
            </div>
          </>
        ))} */}
      {/* Foundation Role dependent fields */}
      {foundationRoleName &&
        (foundationRoleName.toLowerCase() === "defendant" ? (
          <>
            {/* Plaintiff */}
            <div className="py-2">
              <Field
                type="text"
                label="Plaintiff*"
                onChange={onChangePlaintiff}
              />
            </div>

            {/* Impleader */}
            <div className="py-2">
              <Field
                type="text"
                label="Impleader"
                onChange={onChangeImpleader}
              />
            </div>
          </>
        ) : foundationRoleName.toLowerCase() === "plaintiff" ? (
          <>
            {/* Defendant */}
            <div className="py-2">
              <Field
                type="text"
                label="Defendant*"
                onChange={onChangeDefendant}
              />
            </div>

            {/* Impleader */}
            <div className="py-2">
              <Field
                type="text"
                label="Impleader"
                onChange={onChangeImpleader}
              />
            </div>
          </>
        ) : foundationRoleName.toLowerCase() === "impleader" ? (
          <>
            {/* Plaintiff */}
            <div className="py-2">
              <Field
                type="text"
                label="Plaintiff*"
                onChange={onChangePlaintiff}
              />
            </div>

            {/* Defendant */}
            <div className="py-2">
              <Field
                type="text"
                label="Defendant*"
                onChange={onChangeDefendant}
              />
            </div>
          </>
        ) : foundationRoleName.toLowerCase() === "appellant" ? (
          <>
            {/* Respondent */}
            <div className="py-2">
              <Field
                type="text"
                label="Respondent*"
                onChange={onChangeRespondent}
              />
            </div>

            {/* Intervenor */}
            <div className="py-2">
              <Field
                type="text"
                label="Intervenor"
                onChange={onChangeIntervenor}
              />
            </div>
          </>
        ) : foundationRoleName.toLowerCase() === "respondent" ? (
          <>
            {/* Appellant */}
            <div className="py-2">
              <Field
                type="text"
                label="Appellant*"
                onChange={onChangeAppellant}
              />
            </div>

            {/* Intervenor */}
            <div className="py-2">
              <Field
                type="text"
                label="Intervenor"
                onChange={onChangeIntervenor}
              />
            </div>
          </>
        ) : foundationRoleName.toLowerCase() === "intervenor" ? (
          <>
            {/* Appellant */}
            <div className="py-2">
              <Field
                type="text"
                label="Appellant*"
                onChange={onChangeAppellant}
              />
            </div>

            {/* Respondent */}
            <div className="py-2">
              <Field
                type="text"
                label="Respondent*"
                onChange={onChangeRespondent}
              />
            </div>
          </>
        ) : (
          <>
            {/* No Role Only Tracking */}
            <div className="py-2">
              <Field
                type="text"
                label="Plaintiff*"
                onChange={onChangePlaintiff}
              />
            </div>

            <div className="py-2">
              <Field
                type="text"
                label="Defendant*"
                onChange={onChangeDefendant}
              />
            </div>

            <div className="py-2">
              <Field
                type="text"
                label="Impleader"
                onChange={onChangeImpleader}
              />
            </div>
          </>
        ))}
      {/* Status */}
      <div className="py-2">
        <DropDown
          title="Current Status*"
          placeholder="None"
          responseData={responseDataStatus}
          labelKey={courtStatus}
          valueKey={selectedCourtStatus}
          value={currentStatus}
          onChange={onChangeStatus}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>

      {/* Court Stage */}
      <div className="py-2">
        <DropDown
          title="Court Stage*"
          placeholder="Select"
          responseData={courtStages || []}
          labelKey="stage"
          valueKey="stage"
          value={selectedCourtStage}
          onChange={(e) => setSelectedCourtStage(e.target.value)}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>

      {/* Summary */}
      <div className="py-2">
        <Field type="text" label="Summary" onChange={onChangeSummary} />
      </div>

      {/* Case Requirement */}
      <div className="py-2">
        <Field
          type="text"
          label="Case Requirement"
          onChange={onChangeCaseRequirement}
        />
      </div>

      {/* Advocate Name */}
      <div className="py-2">
        <Field
          type="text"
          label="Advocate Name*"
          onChange={onChangeAdvocateName}
        />
      </div>

      {/* Contact Number */}
      <div className="py-2">
        <Field
          type="text"
          label="Contact Number*"
          onChange={onChangeContactNumber}
        />
      </div>

      {/* Dates */}
      <div className="py-2 grid grid-cols-2 gap-5">
        <DatePickerField
          label="Original Suite Date*"
          value={OriginalSuiteDate}
          onChange={onChangeOriginalSuiteDate}
        />

        <DatePickerField
          label="Last Date"
          value={LastDate}
          onChange={onChangeLastDate}
        />

        <DatePickerField
          label="Next Hearing Date"
          value={NextHearingDate}
          onChange={onChangeNextHearingDate}
        />

        <DatePickerField
          label="Closure Date"
          value={ClosureDate}
          onChange={onChangeClosureDate}
        />
      </div>

      {/* Dates */}

      {/* <div className="py-2 flex space-x-5">
        <DatePickerField
          label="Original Suite Date*"
          value={OriginalSuiteDate}
          onChange={onChangeOriginalSuiteDate}
        />
        <DatePickerField
          label="Next Hearing Date"
          value={NextHearingDate}
          onChange={onChangeNextHearingDate}
        />
        <DatePickerField
          label="Closure Date"
          value={ClosureDate}
          onChange={onChangeClosureDate}
        />
      </div> */
      }
    </>
  );
};

export const EditDescription = ({
  isAdmin,
  onChange,
  description,
  state,
  location,
  site,
  isEditing,
  siteName,
  siteType,
  propertyTaxData,
  selectedPropertyTax,
  onChangePropertyTax,
}) => {
  return (
    <>
      <div className="py-2">
        <Field type="text" label="State*" value={state} disabled={isEditing} />
      </div>

      <div className="py-2">
        <Field
          type="text"
          label="Location*"
          value={location}
          disabled={isEditing}
        />
      </div>

      <div className="py-2 hidden">
        <Field type="text" label="Site*" value={site} disabled={isEditing} />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Site Name*"
          value={siteName}
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Site Type*"
          value={siteType}
          disabled={true} // usually not editable
        />
      </div>
      <div className="py-2">
        <DropDown
          title="Property Tax Applicability*"
          placeholder="Select Property Tax Applicability"
          responseData={propertyTaxData}
          labelKey="name"
          valueKey="property_tax_applicability_id"
          value={selectedPropertyTax}
          onChange={onChangePropertyTax}
          disabled={!isAdmin}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Site Description"
          value={description}
          onChange={onChange}
        />
      </div>
    </>
  );
};

// export const EditCourtCase = ({
//   siteName,
//   responseDataUniqueNo,
//   uniqueNoName,
//   selectedUniqueId,
//   uniqueNoId,
//   onChangeUniqueNo,
//   setSelectedUnique,
//   OSUiteNo,
//   currentStatus,
//   onChangeStatus,
//   NextHearingDate,
//   onChangeNextHearingDate,
//   ClosureDate,
//   onChangeClosureDate,
//   summary,
//   onChangeSummary,
//   courtStatus,
//   selectedCourtStatus,
//   responseDataStatus,
//   isEditing,
//   stateName,
//   locationName,
//   OriginalSuiteDate,
//   onChangeOriginalSuiteDate,
//   areaUnderLitigationAcre,
//   onChangeLitigationAcre,
//   areaUnderLitigationGunta,
//   onChangeLitigationGunta,

//   foundationRoleId,
//   onChangeFoundationRole,
//   foundationRoleName,

//   plaintiff,
//   defendant,
//   impleader,
//   respondent,
//   intervenor,
//   appellant,

//   onChangePlaintiff,
//   onChangeDefendant,
//   onChangeImpleader,
//   onChangeRespondent,
//   onChangeIntervenor,
//   onChangeAppellant,

//   // NEW EDIT FIELDS
//   onChangeLastDate,
//   LastDate,
//   onChangeAdvocateName,
//   onChangeContactNumber,
//   onChangeCaseRequirement,
//   onChangeCnrNumber,

//   // COURT STAGE
//   courtStages,
//   selectedCourtStage,
//   setSelectedCourtStage,

//   siteType,
//   caseTypes,
//   selectedCaseType,
//   setSelectedCaseType,
//   onChangeOriginalSuite,
// }) => {
//   const [foundationRoles, setFoundationRoles] = useState([]);
//   // ✅ ADD HERE
//   const isLand = siteType?.toLowerCase() !== "others";
//   useEffect(() => {
//     const loadRoles = async () => {
//       try {
//         const roles = await fetchFoundationRoles();
//         setFoundationRoles(roles); // roles is now an array
//       } catch (error) {
//         console.error("Error fetching foundation roles:", error);
//       }
//     };
//     loadRoles();
//   }, []);
//   // const filteredCaseTypes =
//   //   caseTypes?.filter((item) => item.name?.toLowerCase() !== "land") || [];
//   return (
//     <>
//       <div className="py-2">
//         <Field label="State*" value={stateName} disabled={isEditing} />
//       </div>
//       <div className="py-2">
//         <Field label="Location*" value={locationName} disabled={isEditing} />
//       </div>
//       <div className="py-2">
//         <Field label="Site*" value={siteName} disabled={isEditing} />
//       </div>
//       <div className="py-2">
//         <Field
//           type="text"
//           label="CNR Number"
//           value={cnrNumber}
//           onChange={onChangeCnrNumber}
//         />
//       </div>
//       <div className="py-2">
//         <Field
//           type="text"
//           label="Court Case Type*"
//           value={
//             caseTypes?.find((item) => item.case_type_id === selectedCaseType)
//               ?.name || ""
//           }
//           disabled={true}
//         />
//       </div>

//       {siteType?.toLowerCase() !== "others" && (
//         <div className="py-2">
//           <Autocomplete
//             multiple
//             id="multi-select-unique-no"
//             options={responseDataUniqueNo}
//             getOptionLabel={(option) => option.unique_survey_no}
//             value={uniqueNoId}
//             onChange={(event, newValue) => {
//               setSelectedUnique(newValue);
//             }}
//             renderInput={(params) => {
//               // ✅ Get selected case object
//               const selectedCaseObj = caseTypes?.find(
//                 (c) => c.case_type_id === selectedCaseType,
//               );

//               // ✅ Check if case type is Land
//               const isLandCase =
//                 selectedCaseObj?.name === "Land" || selectedCaseType === "Land";

//               return (
//                 <TextField
//                   {...params}
//                   variant="outlined"
//                   placeholder="Select"
//                   label={
//                     <>
//                       Unique Survey No
//                       {isLandCase && <span style={{ color: "grey" }}> *</span>}
//                     </>
//                   }
//                   InputLabelProps={{ shrink: true }}
//                 />
//               );
//             }}
//             sx={{ width: 550 }}
//           />
//         </div>
//       )}
//       <div className="py-2">
//         <Field
//           type="text"
//           label="Original Suite No*"
//           value={OSUiteNo}
//           onChange={onChangeOriginalSuite}
//         />
//       </div>
//       {isLand && (
//         <>
//           <div className="py-2">
//             <Field
//               type="text"
//               label="Area under Litigation in Acre"
//               value={areaUnderLitigationAcre}
//               onChange={onChangeLitigationAcre}
//             />
//           </div>

//           <div className="py-2">
//             <Field
//               type="text"
//               label="Area under Litigation in Gunta"
//               value={areaUnderLitigationGunta}
//               onChange={onChangeLitigationGunta}
//             />
//           </div>
//         </>
//       )}
//       <div className="py-2">
//         <DropDown
//           title="Foundation Role*"
//           placeholder="Select"
//           responseData={foundationRoles}
//           labelKey="role_name" // show role_name in dropdown
//           valueKey="foundation_role_id" // use foundation_role_id as value
//           value={foundationRoleId} // this should now be the ID (e.g., 3)
//           onChange={(e) => {
//             const selectedId = e.target.value;
//             const selectedRole = foundationRoles.find(
//               (r) => r.foundation_role_id === selectedId,
//             );
//             onChangeFoundationRole(selectedId, selectedRole?.role_name);
//           }}
//           sx={{ "& .MuiTextField-root": { width: "550px" } }}
//         />
//       </div>
//       {foundationRoleName &&
//         (foundationRoleName.toLowerCase() === "defendant" ? (
//           <>
//             {/* Plaintiff */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Plaintiff*"
//                 value={plaintiff}
//                 onChange={onChangePlaintiff}
//               />
//             </div>

//             {/* Impleader */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Impleader"
//                 value={impleader}
//                 onChange={onChangeImpleader}
//               />
//             </div>
//           </>
//         ) : foundationRoleName.toLowerCase() === "plaintiff" ? (
//           <>
//             {/* Defendant */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Defendant*"
//                 value={defendant}
//                 onChange={onChangeDefendant}
//               />
//             </div>

//             {/* Impleader */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Impleader"
//                 value={impleader}
//                 onChange={onChangeImpleader}
//               />
//             </div>
//           </>
//         ) : foundationRoleName.toLowerCase() === "impleader" ? (
//           <>
//             {/* Plaintiff */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Plaintiff*"
//                 value={plaintiff}
//                 onChange={onChangePlaintiff}
//               />
//             </div>

//             {/* Defendant */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Defendant*"
//                 value={defendant}
//                 onChange={onChangeDefendant}
//               />
//             </div>
//           </>
//         ) : foundationRoleName.toLowerCase() === "appellant" ? (
//           <>
//             {/* Respondent */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Respondent*"
//                 value={respondent}
//                 onChange={onChangeRespondent}
//               />
//             </div>

//             {/* Intervenor */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Intervenor"
//                 value={intervenor}
//                 onChange={onChangeIntervenor}
//               />
//             </div>
//           </>
//         ) : foundationRoleName.toLowerCase() === "respondent" ? (
//           <>
//             {/* Appellant */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Appellant*"
//                 value={appellant}
//                 onChange={onChangeAppellant}
//               />
//             </div>

//             {/* Intervenor */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Intervenor"
//                 value={intervenor}
//                 onChange={onChangeIntervenor}
//               />
//             </div>
//           </>
//         ) : foundationRoleName.toLowerCase() === "intervenor" ? (
//           <>
//             {/* Appellant */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Appellant*"
//                 value={appellant}
//                 onChange={onChangeAppellant}
//               />
//             </div>

//             {/* Respondent */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Respondent*"
//                 value={respondent}
//                 onChange={onChangeRespondent}
//               />
//             </div>
//           </>
//         ) : (
//           <>
//             {/* No Role Only Tracking */}
//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Plaintiff*"
//                 value={plaintiff}
//                 onChange={onChangePlaintiff}
//               />
//             </div>

//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Defendant*"
//                 value={defendant}
//                 onChange={onChangeDefendant}
//               />
//             </div>

//             <div className="py-2">
//               <Field
//                 type="text"
//                 label="Impleader"
//                 value={impleader}
//                 onChange={onChangeImpleader}
//               />
//             </div>
//           </>
//         ))}
//       <div className="py-2">
//         <DropDown
//           title="Current Status*"
//           placeholder="None"
//           responseData={responseDataStatus}
//           labelKey={courtStatus}
//           valueKey={selectedCourtStatus}
//           value={currentStatus} // ✅ PASS THE ID
//           onChange={onChangeStatus}
//           sx={{ "& .MuiTextField-root": { width: "550px" } }}
//         />
//       </div>
//       {/* Court Stage */}
//       <div className="py-2">
//         <DropDown
//           title="Court Stage*"
//           placeholder="Select"
//           responseData={courtStages || []}
//           labelKey="stage"
//           valueKey="stage"
//           value={selectedCourtStage}
//           onChange={(e) => setSelectedCourtStage(e.target.value)}
//           sx={{ "& .MuiTextField-root": { width: "550px" } }}
//         />
//       </div>
//       <div className="py-2">
//         <Field
//           type="text"
//           label="Summary"
//           value={summary}
//           onChange={onChangeSummary}
//         />
//       </div>
//       {/* Case Requirement */}
//       <div className="py-2">
//         <Field
//           type="text"
//           label="Case Requirement"
//           value={caseRequirement}
//           onChange={onChangeCaseRequirement}
//         />
//       </div>

//       {/* Advocate Name */}
//       <div className="py-2">
//         <Field
//           type="text"
//           label="Advocate Name"
//           value={advocateName}
//           onChange={onChangeAdvocateName}
//         />
//       </div>

//       {/* Contact Number */}
//       <div className="py-2">
//         <Field
//           type="text"
//           label="Contact Number"
//           value={contactNumber}
//           onChange={onChangeContactNumber}
//         />
//       </div>
//       <div className="py-2 grid grid-cols-2 gap-5">
//         <DatePickerField
//           label="Original Suite Date*"
//           value={OriginalSuiteDate}
//           onChange={onChangeOriginalSuiteDate}
//         />

//         <DatePickerField
//           label="Last Date"
//           value={LastDate}
//           onChange={onChangeLastDate}
//         />

//         <DatePickerField
//           label="Next Hearing Date"
//           value={NextHearingDate}
//           onChange={onChangeNextHearingDate}
//         />

//         <DatePickerField
//           label="Closure Date"
//           value={ClosureDate}
//           onChange={onChangeClosureDate}
//         />
//       </div>
//     </>
//   );
// };
export const EditCourtCase = ({
  siteName,
  responseDataUniqueNo,
  uniqueNoName,
  selectedUniqueId,
  uniqueNoId,
  onChangeUniqueNo,
  setSelectedUnique,
  courtCaseDetails,
onChangeCourtCaseDetails,

  OSUiteNo,
  currentStatus,
  onChangeStatus,

  NextHearingDate,
  onChangeNextHearingDate,

  ClosureDate,
  onChangeClosureDate,

  summary,
  onChangeSummary,

  courtStatus,
  selectedCourtStatus,
  responseDataStatus,

  isEditing,
  stateName,
  locationName,

  OriginalSuiteDate,
  onChangeOriginalSuiteDate,

  areaUnderLitigationAcre,
  onChangeLitigationAcre,

  areaUnderLitigationGunta,
  onChangeLitigationGunta,

  // Foundation Role
  foundationRoleId,
  onChangeFoundationRole,
  foundationRoleName,

  // Existing Foundation Role fields
  plaintiff,
  defendant,
  impleader,

  // New Foundation Role fields
  respondent,
  intervenor,
  appellant,

  onChangePlaintiff,
  onChangeDefendant,
  onChangeImpleader,
  onChangeRespondent,
  onChangeIntervenor,
  onChangeAppellant,

  // ==========================================
  // NEW EDIT FIELDS
  // ==========================================

  cnrNumber,
  onChangeCnrNumber,

  caseRequirement,
  onChangeCaseRequirement,

  advocateName,
  onChangeAdvocateName,

  contactNumber,
  onChangeContactNumber,

  LastDate,
  onChangeLastDate,

  // ==========================================
  // COURT STAGE
  // ==========================================

  courtStages,
  selectedCourtStage,
  setSelectedCourtStage,

  // ==========================================
  // OTHER
  // ==========================================

  siteType,
  caseTypes,
  selectedCaseType,
  setSelectedCaseType,

  onChangeOriginalSuite,
}) => {
  const [foundationRoles, setFoundationRoles] = useState([]);

  const isLand = siteType?.toLowerCase() !== "others";

  useEffect(() => {
    const loadRoles = async () => {
      try {
        const roles = await fetchFoundationRoles();
        setFoundationRoles(roles);
      } catch (error) {
        console.error("Error fetching foundation roles:", error);
      }
    };

    loadRoles();
  }, []);

  return (
    <>
      {/* ==========================================
          STATE
      ========================================== */}

      <div className="py-2">
        <Field
          label="State*"
          value={stateName}
          disabled={isEditing}
        />
      </div>

      {/* ==========================================
          LOCATION
      ========================================== */}

      <div className="py-2">
        <Field
          label="Location*"
          value={locationName}
          disabled={isEditing}
        />
      </div>

      {/* ==========================================
          SITE
      ========================================== */}

      <div className="py-2">
        <Field
          label="Site*"
          value={siteName}
          disabled={isEditing}
        />
      </div>

      {/* ==========================================
          CNR NUMBER
          After Site Name
      ========================================== */}

      <div className="py-2">
        <Field
          type="text"
          label="CNR Number*"
          value={cnrNumber}
          onChange={onChangeCnrNumber}
        />
      </div>

      {/* ==========================================
          COURT CASE TYPE
      ========================================== */}

      <div className="py-2">
        <Field
          type="text"
          label="Court Case Type*"
          value={
            caseTypes?.find(
              (item) => item.case_type_id === selectedCaseType
            )?.name || ""
          }
          disabled={true}
        />
      </div>

      {/* ==========================================
          UNIQUE SURVEY NUMBER
      ========================================== */}

      {siteType?.toLowerCase() !== "others" && (
        <div className="py-2">
          <Autocomplete
            multiple
            id="multi-select-unique-no"
            options={responseDataUniqueNo}
            getOptionLabel={(option) => option.unique_survey_no}
            value={uniqueNoId}
            onChange={(event, newValue) => {
              setSelectedUnique(newValue);
            }}
            renderInput={(params) => {
              const selectedCaseObj = caseTypes?.find(
                (c) => c.case_type_id === selectedCaseType
              );

              const isLandCase =
                selectedCaseObj?.name === "Land" ||
                selectedCaseType === "Land";

              return (
                <TextField
                  {...params}
                  variant="outlined"
                  placeholder="Select"
                  label={
                    <>
                      Unique Survey No
                      {isLandCase && (
                        <span style={{ color: "grey" }}> *</span>
                      )}
                    </>
                  }
                  InputLabelProps={{ shrink: true }}
                />
              );
            }}
            sx={{ width: 550 }}
          />
        </div>
      )}

      {/* ==========================================
          ORIGINAL SUITE NUMBER
      ========================================== */}

      <div className="py-2">
        <Field
          type="text"
          label="Original Suite No*"
          value={OSUiteNo}
          onChange={onChangeOriginalSuite}
        />
      </div>
{/* Court Case Details */}
<div className="py-2">
  <Field
    type="text"
    label="Court Details*"

     value={courtCaseDetails || ""}
   onChange={onChangeCourtCaseDetails}
  />
</div>
      {/* ==========================================
          LAND LITIGATION FIELDS
      ========================================== */}

      {isLand && (
        <>
          <div className="py-2">
            <Field
              type="text"
              label="Area under Litigation in Acre"
              value={areaUnderLitigationAcre}
              onChange={onChangeLitigationAcre}
            />
          </div>

          <div className="py-2">
            <Field
              type="text"
              label="Area under Litigation in Gunta"
              value={areaUnderLitigationGunta}
              onChange={onChangeLitigationGunta}
            />
          </div>
        </>
      )}

      {/* ==========================================
          FOUNDATION ROLE
      ========================================== */}

      <div className="py-2">
        <DropDown
          title="Foundation Role*"
          placeholder="Select"
          responseData={foundationRoles}
          labelKey="role_name"
          valueKey="foundation_role_id"
          value={foundationRoleId}
          onChange={(e) => {
            const selectedId = e.target.value;

            const selectedRole = foundationRoles.find(
              (r) => r.foundation_role_id === selectedId
            );

            onChangeFoundationRole(
              selectedId,
              selectedRole?.role_name
            );
          }}
          sx={{
            "& .MuiTextField-root": {
              width: "550px",
            },
          }}
        />
      </div>

      {/* ==========================================
          FOUNDATION ROLE RELATED FIELDS
      ========================================== */}

      {foundationRoleName &&
        (
          foundationRoleName.toLowerCase() === "defendant" ? (
            <>
              {/* Plaintiff */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Plaintiff*"
                  value={plaintiff}
                  onChange={onChangePlaintiff}
                />
              </div>

              {/* Impleader */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Impleader"
                  value={impleader}
                  onChange={onChangeImpleader}
                />
              </div>
            </>
          ) : foundationRoleName.toLowerCase() === "plaintiff" ? (
            <>
              {/* Defendant */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Defendant*"
                  value={defendant}
                  onChange={onChangeDefendant}
                />
              </div>

              {/* Impleader */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Impleader"
                  value={impleader}
                  onChange={onChangeImpleader}
                />
              </div>
            </>
          ) : foundationRoleName.toLowerCase() === "impleader" ? (
            <>
              {/* Plaintiff */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Plaintiff*"
                  value={plaintiff}
                  onChange={onChangePlaintiff}
                />
              </div>

              {/* Defendant */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Defendant*"
                  value={defendant}
                  onChange={onChangeDefendant}
                />
              </div>
            </>
          ) : foundationRoleName.toLowerCase() === "appellant" ? (
            <>
              {/* Respondent */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Respondent*"
                  value={respondent}
                  onChange={onChangeRespondent}
                />
              </div>

              {/* Intervenor */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Intervenor"
                  value={intervenor}
                  onChange={onChangeIntervenor}
                />
              </div>
            </>
          ) : foundationRoleName.toLowerCase() === "respondent" ? (
            <>
              {/* Appellant */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Appellant*"
                  value={appellant}
                  onChange={onChangeAppellant}
                />
              </div>

              {/* Intervenor */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Intervenor"
                  value={intervenor}
                  onChange={onChangeIntervenor}
                />
              </div>
            </>
          ) : foundationRoleName.toLowerCase() === "intervenor" ? (
            <>
              {/* Appellant */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Appellant*"
                  value={appellant}
                  onChange={onChangeAppellant}
                />
              </div>

              {/* Respondent */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Respondent*"
                  value={respondent}
                  onChange={onChangeRespondent}
                />
              </div>
            </>
          ) : (
            <>
              {/* No Role / Only Tracking */}

              {/* Plaintiff */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Plaintiff*"
                  value={plaintiff}
                  onChange={onChangePlaintiff}
                />
              </div>

              {/* Defendant */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Defendant*"
                  value={defendant}
                  onChange={onChangeDefendant}
                />
              </div>

              {/* Impleader */}
              <div className="py-2">
                <Field
                  type="text"
                  label="Impleader"
                  value={impleader}
                  onChange={onChangeImpleader}
                />
              </div>
            </>
          )
        )}

      {/* ==========================================
          CURRENT STATUS
      ========================================== */}

      <div className="py-2">
        <DropDown
          title="Current Status*"
          placeholder="None"
          responseData={responseDataStatus}
          labelKey={courtStatus}
          valueKey={selectedCourtStatus}
          value={currentStatus}
          onChange={onChangeStatus}
          sx={{
            "& .MuiTextField-root": {
              width: "550px",
            },
          }}
        />
      </div>

      {/* ==========================================
          COURT STAGE
      ========================================== */}

      <div className="py-2">
        <DropDown
          title="Court Stage*"
          placeholder="Select"
          responseData={courtStages || []}
          labelKey="stage"
          valueKey="stage"
          value={selectedCourtStage}
          onChange={(e) =>
            setSelectedCourtStage(e.target.value)
          }
          sx={{
            "& .MuiTextField-root": {
              width: "550px",
            },
          }}
        />
      </div>

      {/* ==========================================
          SUMMARY
      ========================================== */}

      <div className="py-2">
        <Field
          type="text"
          label="Summary"
          value={summary}
          onChange={onChangeSummary}
        />
      </div>

      {/* ==========================================
          CASE REQUIREMENT
      ========================================== */}

      <div className="py-2">
        <Field
          type="text"
          label="Case Requirement"
          value={caseRequirement}
          onChange={onChangeCaseRequirement}
        />
      </div>

      {/* ==========================================
          ADVOCATE NAME
      ========================================== */}

      <div className="py-2">
        <Field
          type="text"
          label="Advocate Name*"
          value={advocateName}
          onChange={onChangeAdvocateName}
        />
      </div>

      {/* ==========================================
          CONTACT NUMBER
      ========================================== */}

      <div className="py-2">
        <Field
          type="text"
          label="Contact Number*"
          value={contactNumber}
          onChange={onChangeContactNumber}
        />
      </div>

      {/* ==========================================
          DATES
      ========================================== */}

      <div className="py-2 grid grid-cols-2 gap-5">
        {/* Original Suite Date */}
        <DatePickerField
          label="Original Suite Date*"
          value={OriginalSuiteDate}
          onChange={onChangeOriginalSuiteDate}
        />

        {/* Last Date */}
        <DatePickerField
          label="Last Date"
          value={LastDate}
          onChange={onChangeLastDate}
        />

        {/* Next Hearing Date */}
        <DatePickerField
          label="Next Hearing Date"
          value={NextHearingDate}
          onChange={onChangeNextHearingDate}
        />

        {/* Closure Date */}
        <DatePickerField
          label="Closure Date"
          value={ClosureDate}
          onChange={onChangeClosureDate}
        />
      </div>
    </>
  );
};
export const EditSurvey = ({
  siteName,
  responseData,
  nameState,
  stateId,
  onChangeState,
  selectedStateId,
  responseDataLocation,
  nameLocation,
  locationId,
  onChangeLocation,
  selectedLocationId,
  selectedSiteID,
  siteId,
  OSUiteNo,
  onChangeOSUiteNo,
  acre,
  onChangeAcre,
  gunta,
  onChangeGunta,
  karabAcre,
  onChangeKarabAcre,
  karabGunta,
  onChangeKarabGunta,
  isEditing,
  onChangeUniqueNo,
  uniqueNoId,
  onChangeSite,
  responseDataSite,
  no,
}) => {
  console.log("selectedStateId =", selectedStateId);
  console.log("responseData =", responseData);
  return (
    <>
      <div className="py-2">
        <DropDown
          title="State*"
          placeholder="None"
          responseData={responseData}
          labelKey={nameState}
          valueKey={stateId}
          onChange={onChangeState}
          value={selectedStateId}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
          disabled={isEditing}
        />
      </div>

      <div className="py-2">
        <DropDown
          title="Location*"
          placeholder="None"
          responseData={responseDataLocation}
          labelKey={nameLocation}
          valueKey={locationId}
          onChange={onChangeLocation}
          value={selectedLocationId}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <DropDown
          title="Site Name*"
          placeholder="None"
          responseData={responseDataSite}
          labelKey={siteName}
          valueKey={selectedSiteID}
          value={siteId} // ✅ PASS THE ID
          onChange={onChangeSite}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>

      <div className="py-2">
        <Field
          label="Survey No*"
          value={uniqueNoId}
          onChange={onChangeUniqueNo}
          disabled
        />
      </div>

      <div className="py-2">
        <Field
          label="Schedule*"
          value={OSUiteNo}
          onChange={onChangeOSUiteNo}
          disabled
        />
      </div>
      <div className="py-2">
        <Field label="Acre" value={acre} onChange={onChangeAcre} />
      </div>
      <div className="py-2">
        <Field label="Gunta" value={gunta} onChange={onChangeGunta} />
      </div>
      <div className="py-2">
        <Field
          label="Karab in Acres"
          value={karabAcre}
          onChange={onChangeKarabAcre}
        />
      </div>
      <div className="py-2">
        <Field
          label="Karab in Guntas"
          value={karabGunta}
          onChange={onChangeKarabGunta}
        />
      </div>

      <div className="py-2">
        <Field label="Unique Survey No" value={no} disabled={isEditing} />
      </div>
    </>
  );
};

export const UserForm = ({
  onChangeEmail,
  email,
  firstName,
  lastName,
  handleEmailBlur,
  responseDataRole,
  roleName,
  selectedRole,
  roleId,
  onChangeRole,
}) => {
  return (
    <>
      <div className="py-2">
        <Field
          type="text"
          label="Email*"
          onChange={onChangeEmail}
          value={email}
          onBlur={handleEmailBlur}
        />
      </div>

      <div className="py-2">
        <Field type="text" label="First Name*" value={firstName} readOnly />
      </div>
      <div className="py-2">
        <Field type="text" label="Last Name*" value={lastName} readOnly />
      </div>
      <div className="py-2">
        <DropDown
          title="Roles*"
          placeholder="None"
          responseData={responseDataRole}
          labelKey={roleName}
          valueKey={selectedRole}
          value={roleId} // ✅ PASS THE ID
          onChange={onChangeRole}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
    </>
  );
};

export const UserEditForm = ({
  onChangeEmail,
  email,
  firstName,
  lastName,
  handleEmailBlur,
  responseDataRole,
  roleName,
  selectedRole,
  roleId,
  onChangeRole,
  isEditing,
}) => {
  return (
    <>
      <div className="py-2">
        <Field
          type="text"
          label="Email*"
          onChange={onChangeEmail}
          value={email}
          onBlur={handleEmailBlur}
          disabled={isEditing}
        />
      </div>

      <div className="py-2">
        <Field
          type="text"
          label="First Name*"
          value={firstName}
          readOnly
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Last Name*"
          value={lastName}
          readOnly
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <DropDown
          title="Roles*"
          placeholder="None"
          responseData={responseDataRole}
          labelKey={roleName}
          valueKey={selectedRole}
          value={roleId} // ✅ PASS THE ID
          onChange={onChangeRole}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
    </>
  );
};

export const UserPermissionForm = ({
  responseDataState,
  StateId,
  selectedStateID,
  onChangeState,
  responseDataLocation,
  locationId,
  selectedLocationID,
  onChangeLocation,
  responseDataSite,
  siteId,
  selectedSiteID,
  onChangeSite,
  responseDataCategory,
  categoryId,
  selectedDocumentID,
  onChangeCategory,
  selectedDocumentCategory,
  setSelectedDocumentCategory,
  stateName,
  locationName,
  siteName,
  documentName,
  responseDataUser,
  userName,
  selectedUserID,
  userId,
  roleName,
  onChangeUser,
}) => {
  const isStateAdmin = roleName === "State Admin";
  const isLocationAdmin = roleName === "Location Admin";

  return (
    <>
      <div className="py-2">
        <DropDown
          title="User*"
          placeholder="None"
          responseData={responseDataUser}
          labelKey={userName}
          valueKey={selectedUserID}
          value={userId} // ✅ PASS THE ID
          onChange={onChangeUser}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
      {/* ROLE DISABLED */}
      <div className="py-2">
        <TextField
          label="Role"
          value={roleName || ""}
          disabled
          fullWidth
          size="small"
          sx={{ width: 550 }}
        />
      </div>

      <div className="py-2">
        <Autocomplete
          multiple={isStateAdmin}
          id="multi-state-select"
          options={responseDataState || []}
          getOptionLabel={(option) => option[stateName] || ""}
          value={
            roleName === "State Admin" ? StateId || [] : StateId?.[0] || null
          }
          onChange={(event, newValue) => {
            onChangeState(
              roleName === "State Admin"
                ? newValue
                : newValue
                  ? [newValue]
                  : [],
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="State*"
              placeholder="Select States"
            />
          )}
          sx={{ width: 550 }}
        />
      </div>
      {!isStateAdmin &&
        (isLocationAdmin ? (
          <Autocomplete
            multiple
            options={responseDataLocation || []}
            getOptionLabel={(option) => option[locationName] || ""}
            isOptionEqualToValue={(option, value) =>
              option.location_id === value.location_id
            }
            value={Array.isArray(locationId) ? locationId : []}
            onChange={(event, newValue) => {
              onChangeLocation(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Location*"
                placeholder="Select Locations"
              />
            )}
          />
        ) : (
          <DropDown
            title="Location*"
            placeholder="None"
            responseData={responseDataLocation}
            labelKey={locationName}
            valueKey={selectedLocationID}
            value={locationId}
            onChange={onChangeLocation}
            sx={{ "& .MuiTextField-root": { width: "550px" } }}
          />
        ))}

      {!isStateAdmin && !isLocationAdmin && (
        <div className="py-2">
          <DropDown
            title="Site*"
            placeholder="None"
            responseData={responseDataSite}
            labelKey={siteName}
            valueKey={selectedSiteID}
            value={siteId}
            onChange={onChangeSite}
            sx={{ "& .MuiTextField-root": { width: "550px" } }}
          />
        </div>
      )}

      <div className="py-2">
        <Autocomplete
          multiple={!isLocationAdmin}
          id="multi-select-unique-no"
          options={responseDataCategory || []}
          getOptionLabel={(option) => option?.name || ""}
          value={
            isLocationAdmin
              ? selectedDocumentCategory?.[0] || null
              : Array.isArray(selectedDocumentCategory)
                ? selectedDocumentCategory
                : []
          }
          onChange={(event, newValue) => {
            if (isLocationAdmin) {
              setSelectedDocumentCategory(newValue ? [newValue] : []);
            } else {
              setSelectedDocumentCategory(
                Array.isArray(newValue) ? newValue : [],
              );
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Document Category*"
              placeholder="Select"
            />
          )}
          sx={{ width: 550 }}
        />
      </div>
    </>
  );
};

export const EditUserPermissionForm = ({
  responseDataState,
  StateId,
  selectedStateID,
  onChangeState,
  responseDataLocation,
  locationId,
  selectedLocationID,
  onChangeLocation,
  responseDataSite,
  siteId,
  selectedSiteID,
  onChangeSite,
  responseDataCategory,
  categoryId,
  selectedDocumentID,
  setSelectedDocumentCategory,
  selectedDocumentCategory,
  onChangeCategory,
  stateName,
  locationName,
  siteName,
  documentName,
  isEditing,
  roleName,
  userName,
}) => {
  const isStateAdmin = roleName === "State Admin";
  const isLocationAdmin = roleName === "Location Admin";
  console.log("roleName", roleName);
  console.log("locationId", locationId);
  console.log("responseDataLocation", responseDataLocation);
  console.log("selectedLocationID", selectedLocationID);
  return (
    <>
      <div className="py-2">
        <Field
          type="text"
          label="Username*"
          value={userName}
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <TextField
          label="Role"
          value={roleName || ""}
          disabled
          fullWidth
          size="small"
          sx={{ width: 550 }}
        />
      </div>
      <DropDown
        title="State*"
        placeholder="None"
        responseData={responseDataState}
        labelKey={stateName}
        valueKey={selectedStateID}
        value={StateId?.[0]?.state_id || ""}
        onChange={onChangeState}
        sx={{ "& .MuiTextField-root": { width: "550px" } }}
      />
      {!isStateAdmin && (
        <div className="py-2">
          <DropDown
            title="Location*"
            placeholder="None"
            responseData={responseDataLocation}
            labelKey={locationName}
            valueKey={selectedLocationID}
            value={
              isLocationAdmin ? locationId?.[0]?.location_id || "" : locationId
            }
            onChange={onChangeLocation}
            sx={{ "& .MuiTextField-root": { width: "550px" } }}
          />
        </div>
      )}
      {!isStateAdmin && !isLocationAdmin && (
        <div className="py-2">
          <DropDown
            title="Site*"
            placeholder="None"
            responseData={responseDataSite}
            labelKey={siteName}
            valueKey={selectedSiteID}
            value={siteId}
            onChange={onChangeSite}
            sx={{ "& .MuiTextField-root": { width: "550px" } }}
          />
        </div>
      )}

      <div className="py-2">
        {/* <Autocomplete
          multiple={!isLocationAdmin}
          id="multi-select-unique-no"
          options={responseDataCategory} // Array of options
          getOptionLabel={(option) => option.name} // Label shown in the dropdown
          value={
            isLocationAdmin
              ? selectedDocumentCategory?.[0] || null
              : selectedDocumentCategory
          }
          onChange={(event, newValue) => {
            if (isLocationAdmin) {
              setSelectedDocumentCategory(newValue ? [newValue] : []);
            } else {
              setSelectedDocumentCategory(newValue);
            }
          }} */}

        <Autocomplete
          multiple
          id="multi-select-unique-no"
          options={responseDataCategory}
          getOptionLabel={(option) => option.name}
          value={selectedDocumentCategory}
          onChange={(event, newValue) => {
            setSelectedDocumentCategory(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Document Category*"
              placeholder="Select"
            />
          )}
          sx={{ width: 550 }}
        />
      </div>
    </>
  );
};

export const CreateBuilding = ({
  siteName,
  isEditing,
  nameBuildingCode,
  nameBuilding,
  onChangeBuildingCode,
  onChangeBuildingName,
  stateName,
  location,
}) => {
  return (
    <>
      <div className="py-2">
        <Field
          type="text"
          label="State*"
          value={stateName}
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Location*"
          value={location}
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Site*"
          value={siteName}
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Building Name*"
          value={nameBuilding}
          onChange={onChangeBuildingName}
        />
      </div>
    </>
  );
};

export const EditBuilding = ({
  siteName,
  isEditing,
  nameBuildingCode,
  nameBuilding,
  onChangeBuildingCode,
  onChangeBuildingName,
  stateName,
  location,
}) => {
  return (
    <>
      <div className="py-2">
        <Field
          type="text"
          label="State*"
          value={stateName}
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Location*"
          value={location}
          disabled={isEditing}
        />
      </div>
      <div className="py-2">
        <Field
          type="text"
          label="Site*"
          value={siteName}
          disabled={isEditing}
        />
      </div>

      <div className="py-2">
        <Field
          type="text"
          label="Building Name*"
          value={nameBuilding}
          onChange={onChangeBuildingName}
        />
      </div>
    </>
  );
};

export const BorrrowalForm = ({
  documentId,
  responseDataBorrowal,
  userName,
  borrowal,
  borrowalId,
  onChangeBorrowal,
}) => {
  return (
    <>
      <div className="py-2">
        <Field type="text" label="Document Name*" value={documentId} />
      </div>
      <div className="py-2">
        <DropDown
          title="Borrowal*"
          placeholder="None"
          responseData={responseDataBorrowal}
          labelKey={borrowal}
          valueKey={borrowalId}
          value={userName} // ✅ PASS THE ID
          onChange={onChangeBorrowal}
          sx={{ "& .MuiTextField-root": { width: "550px" } }}
        />
      </div>
    </>
  );
};

export const ReturnForm = ({ documentId }) => {
  return (
    <>
      <div className="py-2">
        <Field type="text" label="Document Name*" value={documentId} />
      </div>
    </>
  );
};
